// src/components/store/sections/blog-posts/BlogV90OrigamiribbonFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV90OrigamiribbonFuchsiaGlow(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={90}
      archKey="origami_ribbon"
      archLabel="Origami Ribbon Articles"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
